  document.addEventListener('DOMContentLoaded', function () {
  function stripDecimals() {
    document.querySelectorAll('.price-item, .price, [data-product-price], .product__price').forEach(el => {
      el.innerHTML = el.innerHTML.replace(/(\d+)\.\d{1,2}/g, '$1'); // keep only whole number
    });
  }

  // Run on initial page load
  stripDecimals();

  // Re-run when Shopify reloads sections
  document.addEventListener('shopify:section:load', stripDecimals);
  document.addEventListener('shopify:section:reorder', stripDecimals);

  // Re-run when variant is changed
  document.querySelectorAll('select[name="id"]').forEach(select => {
    select.addEventListener('change', function () {
      setTimeout(stripDecimals, 100); // wait for DOM to update
    });
  });
});
